<template>
    <div class="popup type2" id="firstReservePopup" :class="{ active: popupVisible }">
        <div class="popup__inner type2">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2 v-if="$store.state.hospStore.hostNm === '혈액암병원'">첫 방문 환자 예약</h2>
                    <h2 v-else>첫 진료 예약</h2>
                    <button type="button" class="popup__close" @click="hidePopup"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="info">
                        <p>
                            <span v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                                첫 방문 환자 예약
                            </span>
                            <span v-else>
                                첫 진료 예약
                            </span>
                            은 처음 오시는 고객의 편의를 위하여 전문 상담원이 전화로 진료예약을 도와드리는
                            서비스입니다.
                            저희 병원에서 진료를 받으신 적 있는 분은 온라인(모바일, 알림톡, 홈페이지) 등 다른
                            방법을 통해 진료 예약을 진행해 주시기 바랍니다.
                        </p>

                    </div>

                    <h3 class="mb-none">상담시간</h3>
                    <p>평일 09:00~17:00(토요일, 공휴일 제외)</p>

                    <h3>개인정보 수집 · 이용 동의</h3>
                    <div class="text-box-scroll">
                        <div>
                            <p class="point-desc mb">
                                <span class="c-red" v-if="$store.state.hospStore.hostNm === '혈액암병원'">첫 방문 환자 예약 전</span> 
                                <span class="c-red" v-else>첫 진료 예약 전</span> 
                                개인정보 수집·이용에 대한 내용을 반드시 확인해주세요.</p>
                            1. 개인정보 등의 수집·이용 목적: 첫방문 고객 또는 비회원 고객이 빠르게 예약을 진행하기 위한 용도 <br>
                            2. 수집하려는 개인정보 항목: (필수) 이름, 휴대폰번호 <br>
                            <p class="point-desc font-main">3. 개인정보 등의 보유 및 이용 기간: 3개월 후 삭제</p>
                            4. 귀하는 본 개인 정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 동의하지 않을 시에는 빠른예약 서비스를 받으실 수 없습니다. <br>
                            위와 같이 개인 정보를 수집·이용하는데 동의하십니까?
                        </div>
                    </div>
                    <div class="checkbox-wrap">
                        <label  >
                            <input type="checkbox" name="test01" id="test01" v-model="agree">
                            <span class="checkbox-btn"></span>
                            <p><span class="c-red">*</span> 동의합니다</p>
                        </label>
                    </div>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="hidePopup">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="simpleAction">예약신청</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            popupVisible: {
                type: Boolean,
                required: true
            },
            name:'',
            tel: '',
        },
        data() {
            return {
                agree: false,
            }
        },
        methods: {
            simpleAction(){
                if(!this.agree){
                    alert("개인정보 수집 이용에 동의가 필요합니다.")
                    return
                }

                
                this.axios.get(this.api.appointment.simpleReservation, {
                    params: {
                        hospId: this.$store.getters.getHost,
                        type: 'A',
                        name: this.name,
                        tel: this.tel,
                        status: 'I'
                    }
                }).then(response => {
                    alert(response.data.msg)
                    this.hidePopup()
                    if(response.data.success != "Y"){
                        location.reload()
                    }
                }).catch(err => {
                    alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
                    this.hidePopup()
                });
            },
            hidePopup() {
                this.agree = false
                if(!this.popupVisible){
                    document.querySelector('#firstReservePopup').style.display = 'none'
                }
                this.$emit('hide-popup', 'firstVisible');
            },
        },
    }
</script>